import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { NAV, TAGLINE } from "../../lib/content";
import { CONTACT_EMAIL } from "../../lib/assets";
import { Logo } from "./Navbar";
import { WaveDivider } from "./Motion";

export const Footer = () => (
  <footer className="relative bg-navy text-cream" data-testid="footer">
    <div className="bg-cream"><WaveDivider color="#082F49" /></div>
    <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20 grid gap-12 md:grid-cols-[1.4fr_1fr_1fr]">
      <div>
        <div className="[&_span]:text-cream">
          <Logo />
        </div>
        <p className="font-display text-2xl md:text-3xl font-bold mt-6 max-w-sm leading-tight">{TAGLINE}</p>
      </div>
      <div>
        <p className="font-body text-sm uppercase tracking-[0.15em] text-sky mb-4">Explore</p>
        <ul className="space-y-2.5">
          {NAV.filter((n) => n.label !== "Home").map((n) => (
            <li key={n.to}>
              <Link to={n.to} data-testid={`footer-link-${n.to.replace(/\//g, "")}`} className="font-body text-cream/80 hover:text-yellow transition-colors">
                {n.label}
              </Link>
            </li>
          ))}
          <li>
            <a href="/#pricing" data-testid="footer-link-pricing" className="font-body text-cream/80 hover:text-yellow transition-colors">Pricing</a>
          </li>
          <li>
            <Link to="/contact" data-testid="footer-link-contact" className="font-body text-cream/80 hover:text-yellow transition-colors">Contact</Link>
          </li>
        </ul>
      </div>
      <div>
        <p className="font-body text-sm uppercase tracking-[0.15em] text-sky mb-4">Say hello</p>
        <a href={`mailto:${CONTACT_EMAIL}`} data-testid="footer-email" className="inline-flex items-center gap-2 font-display text-lg font-bold text-yellow hover:underline">
          <Mail className="w-5 h-5" /> {CONTACT_EMAIL}
        </a>
        <p className="font-body text-cream/60 text-sm mt-6">© {new Date().getFullYear()} BleuSharks. All rights reserved.</p>
        <Link to="/privacy" data-testid="footer-link-privacy" className="font-body text-cream/60 text-sm mt-2 inline-block hover:text-yellow transition-colors">Privacy Policy</Link>
      </div>
    </div>
  </footer>
);
